__turbopack_context__.v({
  "device": "IUsNTa_device",
  "explained": "IUsNTa_explained",
  "eyebrow": "IUsNTa_eyebrow",
  "field": "IUsNTa_field",
  "fieldCanvas": "IUsNTa_fieldCanvas",
  "glass": "IUsNTa_glass",
  "header": "IUsNTa_header",
  "heading": "IUsNTa_heading",
  "headline": "IUsNTa_headline",
  "hlBreak": "IUsNTa_hlBreak",
  "hlWord": "IUsNTa_hlWord",
  "orbFade": "IUsNTa_orbFade",
  "orbLabel": "IUsNTa_orbLabel",
  "orbLabelText": "IUsNTa_orbLabelText",
  "pill": "IUsNTa_pill",
  "pillRow": "IUsNTa_pillRow",
  "pills": "IUsNTa_pills",
  "pin": "IUsNTa_pin",
  "stat": "IUsNTa_stat",
  "statK": "IUsNTa_statK",
  "statV": "IUsNTa_statV",
  "statsBand": "IUsNTa_statsBand",
  "statsRow": "IUsNTa_statsRow",
  "track": "IUsNTa_track",
  "tri": "IUsNTa_tri",
  "white": "IUsNTa_white",
});
